
const MapEmbed = () => {

    return (
        <div className="map-responsive" 
        >
            <iframe
                title="Karte – Berlin ClearOut"
                className="map-box"
                loading="lazy"
                src="https://www.google.com/maps?q=Brigitte-Reimann-Straße+27,%2010827%20Berlin&amp;output=embed"
            >
            </iframe>
        </div>
    );
};

export default MapEmbed;